import { useMutation, useQuery } from '@apollo/client';
import {
  SAVE_TICKET,
  SAVE_TICKET_CONVERSATION,
  GET_DEFAULT_TICKET_FORM,
  GET_DEFAULT_TICKET_FORM_NEW,
  GET_ENTITY_PROPERTIES,
  useCachedQuery
} from '@nile/graphql';
import { TicketSheet } from '@nile/mangifera/src/Components/Sheets';
import { TicketContext, HomeContext } from '@nile/mangifera/src/Contexts';
import {
  AppContext,
  toast,
  Loader,
  useUserMSPCheckHook,
  useActivityTracker
} from '@nile/components';
import React, { useCallback, useContext } from 'react';
import { AccountClient } from '@nile/graphql';
import { withRouter } from 'react-router-dom';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useChatFeatureEnabled } from '@nile/components/src/Pages/SystemTrayChatPage/utils';
import AIFeaturesHook from '@nile/components/src/Utils/aiFeaturesHook';
import TicketSheetNew from '@nile/mangifera/src/Components/Sheets/TicketSheet/TicketSheetNew.tsx';

function NewTicketContainer(props) {
  const { noRedirect } = props;
  const context = useContext(TicketContext);
  const appContext = useContext(AppContext);
  const homeContext = useContext(HomeContext);
  const aiFeatureHook = AIFeaturesHook();
  const flags = useFlags();
  const isChatAvailable = useChatFeatureEnabled();
  const runbookRevampFlag = flags?.unifiedRunbooks;

  const defaultFormQuery = runbookRevampFlag
    ? GET_DEFAULT_TICKET_FORM_NEW
    : GET_DEFAULT_TICKET_FORM;

  const { loading, data: defaultTicketForm, error } = useCachedQuery(
    defaultFormQuery
  );

  const {
    data: entityFields,
    loading: entitiesLoading,
    error: entitiesError
  } = useCachedQuery(GET_ENTITY_PROPERTIES, { client: AccountClient });

  const [saveTicket] = useMutation(SAVE_TICKET, {
    onCompleted({ saveTicket }) {
      /* Close sheet container once an employee created */
      if (saveTicket) {
        toast('success', 'app.toast.newTicket.creation.success');
        useActivityTracker({ event: 'Ticket - Created a ticket' });
      }
    },
    update(cache, { data }) {
      // let ticket = cache.readQuery({query:GET_TICKET_LIST, variables: {
      //   listInfo: options
      // }});
      // cache.writeQuery({
      //   query: GET_TICKET_LIST,
      //   data: {getTicketList: [data.saveTicket, ...ticket.getTicketList]}
      // });
    },
    onError() {
      // toast('error', 'Something went wrong');
    }
  });

  const saveTicketWithAction = (params, source) => {
    saveTicket(params).then((res) => {
      if (res?.data?.saveTicket) {
        if (source === 'CHAT' && flags?.agentChatFe && isChatAvailable) {
          sessionStorage.setItem('OpenChat', true);
        }
        if (noRedirect) {
          context.openTab({
            module: 'TICKET',
            data: {
              subject: res?.data?.saveTicket?.subject,
              displayId: res?.data?.saveTicket?.displayId,
              ticketId: res?.data?.saveTicket?.ticketId
            },
            ticketId: res?.data?.saveTicket?.ticketId
          });
        } else {
          context.closeAndOpenTab(null, {
            module: 'TICKET',
            data: {
              subject: res?.data?.saveTicket?.subject,
              displayId: res?.data?.saveTicket?.displayId,
              ticketId: res?.data?.saveTicket?.ticketId
            },
            ticketId: res?.data?.saveTicket?.ticketId
          });
        }
      }
    });
  };

  const [saveTicketConversation] = useMutation(SAVE_TICKET_CONVERSATION, {
    onCompleted({ saveTicketConversation }) {
      toast('success', 'New node created successfully');
    }
  });

  const back = useCallback(() => {
    props.history.push('/onboard/customfields');
  }, []); // eslint-disable-line

  const actions = {
    primaryAction: saveTicketWithAction,
    secondaryAction: saveTicketConversation,
    back: back,
    primaryActionWithNoRedirect: saveTicket,
    ...props.actions
  };

  if (loading || entitiesLoading) return <Loader />;

  return (
    <>
      <TicketSheet
        isMsp={useUserMSPCheckHook()}
        flags={flags}
        actions={actions}
        aiFeatureHook={aiFeatureHook}
        useActivityTracker={useActivityTracker}
        tab={props.tab}
        activeTab={context.activeTab}
        appContext={appContext}
        context={context}
        homeContext={homeContext}
        defaultTicketForm={defaultTicketForm?.getDefaultTicketForm}
        entitiesMeta={entityFields}
      />
    </>
  );
}

const NewTicketContainerWrapper = (props) => {
  const flags = useFlags();
  const ticketStateManagement = flags?.ticketCreateStateManagement;

  if (ticketStateManagement) {
    return <TicketSheetNew noRedirect={props.noRedirect} />;
  }

  return <NewTicketContainer {...props} />;
};

export default NewTicketContainerWrapper;
